import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const ContentWrapper = ({
  children,
  className = '',
}) => {
  const classes = useStyles()

  return (
    <div className={classes.content}>
      <div className={`${classes.root} ${className}`}>
        {children}
      </div>
    </div>
  )
}

ContentWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

ContentWrapper.defaultProps = {
  className: '',
}

const useStyles = makeStyles((theme) => ({
  content: {
    flex: 1,
    display: 'flex',
    width: '100%',
    flexDirection: 'column-reverse',
    height: 'auto',
    '@media (min-width: 800px)': {
      height: '100%',
      flexDirection: 'row',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
}))

export default ContentWrapper
